// Utility functions to encrypt and decrypt parameters in URLs (e.g. bookId, videoId, chapterId)

const SECRET_KEY = 'TH@gi68flthiH#t7!azodsos';

/**
 * Encrypts a raw ID (number or string) into a URL-safe encrypted string.
 */
export function encryptId(id: string | number | undefined | null): string {
  if (id === undefined || id === null || id === '') return '';
  const str = String(id);
  try {
    let result = '';
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
      result += String.fromCharCode(code);
    }
    return btoa(result).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch (e) {
    return str;
  }
}

/**
 * Decrypts a URL parameter back into the original raw ID.
 * Supports fallback to raw ID if decryption fails or if legacy raw ID was passed.
 */
export function decryptId(encrypted: string | undefined | null): string {
  if (!encrypted) return '';
  try {
    let base64 = encrypted.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
      base64 += '=';
    }
    const decoded = atob(base64);
    let result = '';
    for (let i = 0; i < decoded.length; i++) {
      const code = decoded.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
      result += String.fromCharCode(code);
    }
    if (result && /^[a-zA-Z0-9_\-\.]+$/.test(result)) {
      return result;
    }
    return encrypted;
  } catch (e) {
    return encrypted;
  }
}
